import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import LogoutConfirmationModal from "../buildingPages/modals/LogoutConfirmationModal";
import ChangePasswordModal from "../buildingPages/modals/ChangePasswordModal";

const BACK_API_BASE_URL = process.env.REACT_APP_BACK_API_BASE_URL;

const Header = ({ pageName }) => {
  const navigate = useNavigate();
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const [userName, setUserName] = useState(sessionStorage.getItem("userName"));
  const [userEmail, setUserEmail] = useState(sessionStorage.getItem("email"));

  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    useState(false);

  useEffect(() => {
    const fetchUserAuth = async () => {
      const token = sessionStorage.getItem("token");
      var header = {};
      header["Content-Type"] = "application/json";
      if (token) {
        header["Authorization"] = token;
      }
      try {
        const response = await fetch(`${BACK_API_BASE_URL}/api/auth/userInfo`, {
          method: "GET",
          headers: header,
        });

        if (response.ok) {
          const result = await response.json();
          setUserName(result.userName);
          setUserEmail(result.email);
          setRole(result.role);
          sessionStorage.setItem("userName", result.userName);
          sessionStorage.setItem("email", result.email);
          sessionStorage.setItem("role", result.role);
          sessionStorage.setItem("token", result.token);
          // console.log("---로그인완료!!---")
        } else {
          console.error("Failed to fetch user auth:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching user auth:", error);
      }
    };
    fetchUserAuth();
  }, []);

  const handleLoginRedirect = () => {
    navigate("/login");
  };

  const handleLogout = () => {
    setIsLogoutModalOpen(true);
  };
  const confirmLogout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("building");

    setIsLogoutModalOpen(false);
    window.location.reload();
    navigate("/building-list");
  };

  const handleChangePassword = async (currentPassword, newPassword) => {
    try {
      const response = await fetch(
        `${BACK_API_BASE_URL}/api/user/changePassword`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          method: "POST",
          body: JSON.stringify({
            currentPassword: currentPassword,
            changePassword: newPassword,
          }),
        }
      );

      if (response.ok) {
        alert("비밀번호가 성공적으로 변경되었습니다.");
        setIsChangePasswordModalOpen(false);
      } else {
        const errorData = await response.json();
        alert(errorData.errors[0] || "비밀번호 변경 중 오류가 발생했습니다.");
      }
    } catch (error) {
      console.error("비밀번호 변경 중 오류 발생:", error);
      alert("비밀번호 변경 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className="header">
      <h1 className="header-page-name">{pageName}</h1>
      <div className="user-info">
        {role === "GUEST" || !role ? (
          <div className="lead-to-login">
            <button
              className="login-redirect-button"
              onClick={handleLoginRedirect}
            >
              <img
                src="/leadToLogin.png"
                alt="Login Icon"
                className="login-icon"
              />
              로그인 후 편하게 건물관리 해보세요
            </button>
          </div>
        ) : (
          <div className="logged-in-info-container">
            <img
              src="/loggedinInfo.png"
              alt="Logged In"
              className="logged-in-icon"
            />
            <div className="logged-in-info">
              <div className="logged-in-name">{userName}</div>
              <div className="logged-in-email">{userEmail}</div>
            </div>
            <div className="header-buttons">
              <button className="logout-button" onClick={handleLogout}>
                로그아웃
              </button>
              <button
                className="user-change-password-button"
                onClick={() => setIsChangePasswordModalOpen(true)}
              >
                비밀번호 변경
              </button>
            </div>
          </div>
        )}
      </div>
      <LogoutConfirmationModal
        isOpen={isLogoutModalOpen}
        onClose={() => setIsLogoutModalOpen(false)}
        onConfirm={confirmLogout}
      />
      <ChangePasswordModal
        isOpen={isChangePasswordModalOpen}
        onClose={() => setIsChangePasswordModalOpen(false)}
        onChangePassword={handleChangePassword}
      />
    </div>
  );
};

export default Header;
